module.exports = __webpack_public_path__ + "media/src/components/PersonalAccidentInsurancePage/WhyNeedSection/1-72fc7af52ca10283cca39f4f500ff276.png";